<template>
    <b-modal
        id="edit-faq-label-modal"
        v-model="modal"
        ref="edit-faq-label-modal"
        size="md"
        :title="$t('admin.change_tags')"
        modal-class="apprentice-default-modal edit-faq-label"
        :ok-title="$t('common.save')"
        cancel-variant="outline-primary"
        :cancel-title="$t('common.cancel')"
        @ok="onOk">
        <div class="edit-faq-label">
            <div
                class="errors"
                v-if="hasError">
                <b-alert
                    v-for="(error, index) in errors"
                    v-if="error.error"
                    :key="index"
                    show
                    variant="danger">
                    {{ error.message }}
                </b-alert>
            </div>
            <b-form-group
                class="faq-label-name-group"
                label-for="faq-label-name-input"
                :label="$t('common.name')">
                <template v-slot:label> {{ $t('common.name') }} <span class="required">*</span></template>
                <b-form-input
                    id="faq-label-name-input"
                    v-model="name"
                    :placeholder="$t('admin.name_tags')">
                </b-form-input>
            </b-form-group>
            <b-form-group
                class="faq-label-color-picker-group"
                label-for="faq-label-color-input">
                <template v-slot:label> Kleur: <span class="required">*</span></template>
                <design-2021-colorpicker
                    class="apprentice-color-picker"
                    id="faq-label-color-input"
                    :color="color"
                    @on-close="changeColor">
                </design-2021-colorpicker>
            </b-form-group>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-edit-afaq-modal-component',
    data() {
        return {
            afaqTag: null,
            color: '',
            name: '',
            modal: false,
            hasError: false,
            errors: {
                name: {
                    error: false,
                    message: this.$t('admin.name_field_cannot_be_empty'),
                },
                color: {
                    error: false,
                    message: this.$t('admin.no_color_value_specified'),
                },
            },
        };
    },

    methods: {
        onOk(vbModalEvent) {
            if (this.foundError()) {
                vbModalEvent.preventDefault();
                return;
            }
            let data = {
                name: this.name,
                color: this.color,
            };
            this.alert.saving();
            this.axios.post(this.routes.afaqTagsUpdate(this.afaqTag.id), data).then(
                (response) => {
                    this.$emit('updateTags', response.data);
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        show(tag) {
            this.afaqTag = tag;
            this.name = tag.name;
            this.color = tag.color;
            this.modal = true;
            this.clearError();
        },
        changeColor(color) {
            this.color = color;
        },

        foundError() {
            this.clearError();

            if (this.name === '') {
                this.hasError = true;
                this.errors.name.error = true;
            }

            if (this.color === '') {
                this.hasError = true;
                this.errors.color.error = true;
            }

            return this.hasError;
        },

        clearError() {
            this.hasError = false;
            this.errors.name.error = false;
            this.errors.color.error = false;
        },
    },
};
</script>

<style scoped></style>
